// const CHANGE_VALUES = 'mrCollection/CHANGE_VALUES';
const SET_SHIPMENT_KEYS = 'mrCollection/SET_SHIPMENT_KEYS';

const changeTime$ = 'mrCollection/changeTime$';
const selectTime$ = 'mrCollection/selectTime$';
const onBlurTimePicker$ = 'mrCollection/onBlurTimePicker$';

const changeDate$ = 'mrCollection/changeDate$';

const changeAddress$ = 'mrCollection/changeAddress$';
const cleanAddress$ = 'mrCollection/cleanAddress$';

const createShipment$ = 'mrCollection/createShipment$';
const ADD_SHIPMENT = 'mrCollection/ADD_SHIPMENT';
const REMOVE_SHIPMENT = 'mrCollection/REMOVE_SHIPMENT';

export default {
  // CHANGE_VALUES,
  SET_SHIPMENT_KEYS,

  changeTime$,
  selectTime$,
  onBlurTimePicker$,

  changeDate$,

  changeAddress$,
  cleanAddress$,

  createShipment$,
  ADD_SHIPMENT,
  REMOVE_SHIPMENT,
};
